import "./GetAQuote.module.css";
import Header from "@/reusable_sections/Header";
import StartYourTransformation from "./sections/StartYourTransformation";
import FrequentlyAskedQuestions from "./sections/FrequentlyAskedQuestions";
import Footer from "@/reusable_sections/Footer";
export default function GetAQuotePage() {
  return <div>
      <Header />
      <StartYourTransformation />
      <FrequentlyAskedQuestions />
      <Footer />
    </div>;
}